// OpcionSinPlan.jsx
//
// #1887 · «No quiero un plan: jornadas por separado», al final de la lista de planes (R33, mockup `jornada_suelta_pago.pdf`,
// pantalla 1). Los precios son los de `GET /me/suelta/` (nunca escritos acá). Solo se dibuja si el backend dice `disponible: true`
// (no durante la prueba, no a Max+, a los sin tope ni a los planes a medida: R77, R78).
// Cubre R33 — .claude/specs/jornada-suelta/
import { Box } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import { preciosTxt } from "../../helpers/suelta-api";

const OpcionSinPlan = ({ oferta, onElegir }) => {
  if (!oferta?.disponible) return null;
  const precios = preciosTxt(oferta);
  const cohorte = oferta.cohorte_precio === "fundador" ? "precio fundador" : "precio de lista";
  return (
    <Box sx={{ mt: 1.75 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.25, color: "var(--text-faint)", fontSize: 12.5 }}>
        <Box sx={{ flex: 1, height: "1px", backgroundColor: "var(--border-soft)" }} />
        o, sin plan
        <Box sx={{ flex: 1, height: "1px", backgroundColor: "var(--border-soft)" }} />
      </Box>
      <Box
        component="button"
        type="button"
        data-testid="suelta-no-quiero-plan"
        onClick={onElegir}
        sx={{
          display: "grid",
          gridTemplateColumns: "auto minmax(0,1fr) auto",
          gap: 1.5,
          alignItems: "center",
          width: "100%",
          textAlign: "left",
          cursor: "pointer",
          p: "12px 14px",
          fontFamily: "inherit",
          borderRadius: "13px",
          color: "var(--text-primary)",
          backgroundColor: "transparent",
          border: "1px dashed rgba(var(--color-primary-rgb), 0.55)",
          "&:hover": { backgroundColor: "rgba(var(--color-primary-rgb), 0.06)" },
          "&:focus-visible": { outline: "2px solid var(--color-primary-soft)", outlineOffset: 2 },
        }}
      >
        <Box sx={{ width: 34, height: 34, borderRadius: "10px", display: "grid", placeItems: "center", backgroundColor: "rgba(var(--color-primary-rgb), 0.14)", color: "var(--accent-onboarding)" }}>
          <ConfirmationNumberOutlinedIcon sx={{ fontSize: 20 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Box sx={{ fontWeight: 700, fontSize: 14, lineHeight: 1.3 }}>No quiero un plan: jornadas por separado</Box>
          <Box data-testid="suelta-no-quiero-plan-precios" sx={{ fontSize: 12, color: "var(--text-muted)", lineHeight: 1.4, mt: 0.25 }}>
            {`${precios}, ${cohorte}. Un solo pago, duran ${oferta.vigencia_dias || 60} días.`}
          </Box>
        </Box>
        <ChevronRightIcon sx={{ color: "var(--accent-onboarding)" }} />
      </Box>
    </Box>
  );
};

export default OpcionSinPlan;
